import { render, staticRenderFns } from "./EvidenciaBHPPantalla.vue?vue&type=template&id=61a3e2ec&"
import script from "./EvidenciaBHPPantalla.vue?vue&type=script&lang=ts&"
export * from "./EvidenciaBHPPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61a3e2ec', component.options)
    } else {
      api.reload('61a3e2ec', component.options)
    }
    module.hot.accept("./EvidenciaBHPPantalla.vue?vue&type=template&id=61a3e2ec&", function () {
      api.rerender('61a3e2ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EvidenciaBHP/EvidenciaBHPPantalla.vue"
export default component.exports